import { ReactComponent as LockIcon } from 'assets/icons/Lock.svg';
import { GuaranteesDialog } from 'common/components/GuaranteesDialog/GuaranteesDialog';
import { DialogComponentProps } from 'common/hooks/useDialog';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { DataProtectionGuarantees } from './DataProtectionGuarantees';

export type DataProtectionGuaranteesDialogProps = DialogComponentProps<void>;

export const DataProtectionGuaranteesDialog: FC<DataProtectionGuaranteesDialogProps> = ({
  instanceId,
  isOpen,
  onReject,
  onResolve,
}) => {
  const { t } = useTranslation();

  return (
    <GuaranteesDialog
      content={<DataProtectionGuarantees />}
      icon={<LockIcon />}
      instanceId={instanceId}
      isOpen={isOpen}
      onReject={onReject}
      onResolve={onResolve}
      title={t('dataProtectionDialog.title')}
    />
  );
};
